/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * 计算两个时间差经历的时间的文字描述
 * @param {*} timestamp - 毫秒
 */
export const timeCalculate = (start, end) => {
  const label = ['分钟', '小时', '天', '月', '年']
  const unit = [60, 60, 24, 30, 12]
  let restTime = Math.floor((end - start) / 1000)
  let res = ''
  for (let i = 0, len = unit.length; i < len; i++) {
    const pos = len - i // 从年开始算，分钟换算成年 === Math.pow(60, 4)
    const temp = unit.slice(0, pos).reduce((p, c) => p * c, 1)
    const time = Math.floor(restTime / temp)
    time > 0 && (res += time + label[pos - 1])
    restTime -= time * temp
  }
  return res
}

/*
 * 隐藏用户手机号中间四位
 */
export function hidePhone(phone) {
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}
/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return num.toLocaleString('en-US')
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * 数组为空，或者字符为空
 * @param arg
 * @returns {boolean}
 */
export const isEmpty = (arg) => (isArray(arg) ? arg.flat(Infinity).length === 0 : !String(arg ?? ''))
/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}
/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return []
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date(new Date().getTime() - 3600 * 1000 * 24 * 90)
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = Number((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}
/**
 * 数字转百分比
 * @param {Object} point
 */
export function toPercent(point) {
  let str = ''
  if (typeof point === 'number') {
    str = (Math.round(point * 10000) / 100).toFixed() + '%'
  }
  return str
}
/** 百分比转小数 **/
export function toPoint(percent) {
  let str = percent.replace('%', '')
  str = str / 100
  return str
}
// 对象转query字符串的方法 obj=> '?username=我叫胡八一&password=1627889159'
export function queryString(obj) {
  // 首先判断obj是否为真，为真则进行处理，不然直接return
  if (obj) {
    // 定义变量接收query字符串
    let query = ''
    // 循环遍历对象
    // eslint-disable-next-line no-unused-vars
    for (const i in obj) {
      // 定义变量接收对象的value值
      let value = obj[i]
      // 若对象的value值为数组，则进行join打断
      if (Array.isArray(value)) {
        value = value.join(',')
      }
      if (typeof value !== 'object') {
      // 进行字符串拼接
        query += `&${i}=${value}`
      }
    }
    // replace返回一个新的字符串，要用query重新接受一下，并把第一个&替换为?
    query = query.replace('&', '?')
    // 返回生成的query字符串
    return query
  }
  return ''
}

// 下划线转换驼峰
export function toHump(name) {
  return name.replace(/\_(\w)/g, function(all, letter) {
    return letter.toUpperCase()
  })
}

// 生成值区间在(x, y)的随机整数的函数。
export const randomRange = (min, max) => { // min最小值，max最大值
  return Math.floor(Math.random() * (max - min)) + min
}

// 获取字节数
export function getBytesCount(str) {
  var len = 0
  for (var i = 0; i < str.length; i++) {
    // 取出单个字符
    var c = str.charCodeAt(i)
    // 单字节加1 ，0~9，a~z
    if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
      len++
    } else {
      len += 2
    }
  }
  return len
}

/**
 * 获取浏览器上输入的域名，去掉子域名。比如 https://uatin-hr.71360.com/，经过转化获得71360.com
 * @param url
 * @returns {*}
 */
export function formatRequestUrl(url) {
  // 如果请求的URL地址包含DOMAIN_NAME，说明是需要经过转化
  if (url && url.includes('DOMAIN_NAME')) {
    const hostName = window.location.hostname
    const hostNameArr = hostName.split('.')
    const filterHostName = hostNameArr[hostNameArr.length - 2] + '.' + hostNameArr[hostNameArr.length - 1]
    return url.replaceAll('DOMAIN_NAME', filterHostName)
  } else {
    return url
  }
}

/**
 * 获取当前页面的模块
 * @param context
 */
export function getContentModules(context) {
  return context.keys().reduce((component, module) => {
    const componentConfig = context(module).default
    const { name: componentName } = componentConfig
    component[componentName] = componentConfig
    return component
  }, {})
}

/**
 * 判断两个值是否相等
 * @param value1
 * @param value2
 * @returns {boolean}
 */
export const isEqual = function(value1, value2) {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arrayEquals(value1, value2)
  }
  return looseEqual(value1, value2)
}

/**
 * 判断两个数组是否相等
 * @param arrayA
 * @param arrayB
 * @returns {boolean}
 */
export const arrayEquals = function(arrayA, arrayB) {
  arrayA = arrayA || []
  arrayB = arrayB || []

  if (arrayA.length !== arrayB.length) {
    return false
  }

  for (let i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false
    }
  }

  return true
}
/**
 * 判断两个对象是否相等
 * @param a
 * @param b
 * @returns {boolean}
 */
export const looseEqual = function(a, b) {
  const isObjectA = isObject(a)
  const isObjectB = isObject(b)
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b)
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * 判断是否是对象
 * @param obj
 * @returns {boolean}
 */
export const isObject = function(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
/**
 * 格式化数字
 * @param val
 * @returns {string}
 */
export const formatNum = function(val) {
  let num
  val = String(val || '').replace(/[^0-9.]/g, '')
  if (String(val).includes('.')) {
    const [integer, decimal] = String(val).split('.')
    num = integer.slice(0, 14) + '.' + decimal.slice(0, 5)
  } else {
    num = String(val).slice(0, 14)
  }
  return num
}

// 递归获取树形结构的所有节点
export function getOptions(arr) {
  if (arr && arr.length) {
    arr.forEach((e) => {
      e.disabled = false
      if (e.type === 2) {
        delete e.childList
      }
      if (e.type === 1 && (e.childList === undefined || e.childList === null || !e.childList || !e.childList.length || e['containFlag'] !== 1)) {
        e.disabled = true
      }
      if (e.childList && e.childList.length) {
        getOptions(e.childList)
      } else {
        delete e.childList
      }
    })
    return arr
  }
  else { 
	//兼容一下，以免报错
    return []
  }
}

export function changeNumToHan(num) {
  var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
  if (!num || isNaN(num)) return '零'
  var english = num.toString().split('')
  var result = ''
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i// 倒序排列设值
    result = arr2[i] + result
    var arr1_index = english[des_i]
    result = arr1[arr1_index] + result
  }
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
  result = result.replace(/零+$/, '') // 移除末尾的零
  // 将【一十】换成【十】
  result = result.replace(/^一十/g, '十')
  return result
}

// 操作符匹配文字
export function formatRelation(type) {
  switch (type) {
    case 'LIKE':
      return '包含'
    case 'NLIKE':
      return '不包含'
    case 'EQ':
      return '等于'
    case 'NEQ':
      return '不等于'
    case 'IS':
      return '为空'
    case 'ISN':
      return '不为空'
    case 'GT':
      return '大于'
    case 'GTE':
      return '大于等于'
    case 'LT':
      return '小于'
    case 'LTE':
      return '小于等于'
    case 'BETWEEN':
      return '介于'
    case 'EAT':
      return '早于'
    case 'LAT':
      return '晚于'
    case 'PAST_IN_N_DAY':
      return '过去N天'
    case 'NEXT_IN_N_DAY':
      return '未来N天' 
    case 'PAST_ON_N_DAY':
      return '过去第N天'
    case 'NEXT_ON_N_DAY':
      return '未来第N天'
    case 'GT_N_DAY':
      return '晚于N天以后'
    case 'LT_N_DAY':
      return '早于N天以前'
    default:
      return ''
  }
}

// 日期转化周几
export function formatDateToWeek(time) {
  const weekNum = new Date(time).getDay()
  const week = {
    0: '周日',
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六'
  }
  return week[weekNum] ? week[weekNum] : '--'
}


// 计算el 是否存在省略号
export function showtipFunAjx(el) {

  const getPadding = (el) => {
    const style = window.getComputedStyle(el, null)
    const paddingLeft = Number.parseInt(style.paddingLeft, 10) || 0
    const paddingRight = Number.parseInt(style.paddingRight, 10) || 0
    const paddingTop = Number.parseInt(style.paddingTop, 10) || 0
    const paddingBottom = Number.parseInt(style.paddingBottom, 10) || 0
    return {
      left: paddingLeft,
      right: paddingRight,
      top: paddingTop,
      bottom: paddingBottom,
    }
  }

  if(el) {
    const range = document.createRange();
    range.setStart(el, 0)
    range.setEnd(el, el.childNodes.length)
    let rangeWidth = range.getBoundingClientRect().width
    let rangeHeight = range.getBoundingClientRect().height
    const contentWidth = rangeWidth - Math.floor(rangeWidth)
    const { left, right, top, bottom } = getPadding(el)
    const horizontalPadding = left + right
    const verticalPadding = top + bottom
    
    if (rangeWidth + horizontalPadding > el.offsetWidth) {
      return true
    } else {
      return false
    }
  }

}

//获取多少天前的时间，格式 
export function  getFormattedDate(daysAgo = 0, format='yyyy-MM-dd HH:mm:ss') {
  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - daysAgo);

  let year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1;
  let day = currentDate.getDate();
  let hours = currentDate.getHours();
  let minutes = currentDate.getMinutes();
  let seconds = currentDate.getSeconds();

  format = format.replace(/yyyy/g, year);
  format = format.replace(/yy/g, year.toString().slice(-2));
  format = format.replace(/MM/g, ('0' + month).slice(-2));
  format = format.replace(/M/g, month);
  format = format.replace(/dd/g, ('0' + day).slice(-2));
  format = format.replace(/d/g, day);
  format = format.replace(/HH/g, ('0' + hours).slice(-2));
  format = format.replace(/H/g, hours);
  format = format.replace(/mm/g, ('0' + minutes).slice(-2));
  format = format.replace(/m/g, minutes);
  format = format.replace(/ss/g, ('0' + seconds).slice(-2));
  format = format.replace(/s/g, seconds);

  return format;
}

export function getPhonePrefix(phoneTypeCode, phone){
  if(!phoneTypeCode && phone){
    const reg = /^1[3456789]\d{9}$/
    const regExp = /0852\d{8,26}$|0853\d{8,26}$|00886\d{8,25}$/
    const regExp1 = /00\d{8,28}$/
    if(reg.test(phone)){
      return '1722180114687045634'
    }else if(regExp.test(phone)){
      return '1722180147385839617'
    }else if(regExp1.test(phone)){
      return '1722180176620138497'
    }else{
      return ''
    }
  }else{
    return phoneTypeCode
  }
}

export function getAvatarSrc(data) {
  if (!data) {
    return ''
  }
  if (data.startsWith('http') || data.startsWith('data:image')) {
    return data
  }
  return 'data:image/jpeg;base64,' + data
}


export function  getAssistPeople(jobs){     
  if(jobs && jobs.length > 0){
    const obj = {}
    jobs.map(item => {
      for (const key in item) {
        obj[key] = item[key];
      }          
    })
    if(obj.job_01105 && obj.job_01105.showName){
      const ids = JSON.parse(obj.job_01105.showName)
      if(ids && ids.length > 0){
        return ids
      }
    }        
  }
  return []
}

export function setIconDragDual(val) { 
  const dom = $('.icon-drag-dual');
  if(dom.length > 0){
    if(val){
      dom.addClass('icon-drag-dual-hidden');
    }
    else{
      dom.removeClass('icon-drag-dual-hidden');
    }
  }
}

export function createResumeParams(resume) {
  // 如果不是数组，返回空数组
  if (!Array.isArray(resume)) {
    return []
  }

  const result = resume.map(item => ({
    thisDataType: 'dataTypeObject',
    resume_00000: item.resume_00000,
    id: item.id,
    filterId: item.filterId,
    interviewId: item.interviewId,
    fromFilter: item.fromFilter,
    fromMyInterview: item.fromMyInterview,
    resume_00013: item.resume_00013,
    name: item.name,
    resumeDetailScene: item.resumeDetailScene,
    pageId: item.pageId,
    recentLibrary: item.recentLibrary,
    libraryId: item.libraryId,
  }))

  return result
}